import axios from 'axios';
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { buildExpressQuery } from '../../repository/queries/builders';
import useExpress from '../../repository/react-query/useExpress';
import { getUser } from '../../../utils';

const baseEndpoint = '/routes';

const getRoutesQuery = ({ path, ...params }) => {
    const endpoint = path ? `${baseEndpoint}/${path}` : baseEndpoint;
    return useExpress({ endpoint, params });
};

export const useFetchRoutes = ({
    queryKey = 'routes-table',
    path = '',
    queryParams = {},
    ...useQueryOptions // wrap
} = {}) => {
    const user = getUser();
    const { subuser, role, hauling_id, id } = user;
    const haulingId = role === 'transport' ? (subuser ? hauling_id : id) : null;

    const { where = {}, ...rest } = queryParams;
    const whereParams = {
        ...(haulingId && { hauling_companies: haulingId }),
        ...where,
    };

    const queryFn = getRoutesQuery({ path, where: whereParams, ...rest });
    const key = [queryKey, { ...queryParams, where: whereParams }];
    return useQuery({ queryKey: key, queryFn, ...useQueryOptions });
};

const deleteRouteQuery = (id) => {
    const endpoint = `${baseEndpoint}/${id}`;
    return buildExpressQuery(endpoint, {});
};

export const useDeleteRoute = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id) => {
            const query = deleteRouteQuery(id);
            const response = await axios.delete(query);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['routes-table'] });
        },
    });
};
